import { useNotificationDropdown } from '@ztechapps/common.hook'
import { NotificationDropdown } from '@ztechapps/webui.data-tools'

import { routesDef } from '../../../config/routes'

export const NotificationBell = () => {
  const { notifications, loading, handleToggleRead, handleReadAll } = useNotificationDropdown()

  return (
    <NotificationDropdown
      notifications={notifications}
      loading={loading}
      onToggleRead={handleToggleRead}
      onReadAll={handleReadAll}
      notificationListRoute={routesDef.NotificationListPage.path}
    />
  )
}
